import React from "react";
import { PANEL, StrokeIcon } from "./ui";

const Card = ({ message, animation }) => (
  <div className={`px-8 py-10 text-center ${PANEL}`}>
    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-500">
      <StrokeIcon className={`h-8 w-8 ${animation ? "animate-bounce" : ""}`}>
        <path d="M20 6 9 17l-5-5" />
      </StrokeIcon>
    </div>
    <h3 className="mt-5 text-xl font-extrabold text-gray-900 dark:text-white">Success!</h3>
    <p className="mt-2 text-sm text-gray-500 dark:text-slate-400">
      {message ? message : "Your file has been uploaded successfully."}
    </p>
  </div>
);

const SuccessModal = ({ message, isModal }) =>
  isModal ? (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-sm">
        <Card message={message} animation={true} />
      </div>
    </div>
  ) : (
    <Card message={message} />
  );

export default SuccessModal;
